//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Preferences.js";
import "../no/Object.js";
import "../Preferences/Preferences.PartPreferences.js";
let d=[[[0,"AutomaticDimensionColor",1,0],[0,"ConflictingColor",1,0],[0,"ConstantDimensionColor",1,0],[0,"CurveColor",1,0],[0,"DOFColor",1,0],[0,"DimensionColor",1,0],[0,"FullyDefinedColor",1,0],[0,"GeometricConstraintColor",1,0],[0,"InactiveSketchColor",1,0],[0,"LockedObjectColor",1,0],[0,"MovableCurveColor",1,0],[0,"NonWorkRegionColor",1,0],[0,"OutOfDateColor",1,0],[0,"OverconstrainedColor",1,0],[0,"PartiallyDefinedColor",1,0],[0,"ParticipatingDatumColor",1,0],[0,"PersistentRelationColor",1,0],[0,"PreviewDimensionColor",1,0],[0,"ReferenceCurveColor",1,0],[0,"ReferenceDimensionColor",1,0],[0,"RelationColor",1,0],[0,"ShadedRegionColor",1,0],[0,"UnsolvedCurvesColor",1,0],[0,"WorkRegionBoundaryColor",1,0]],[],[]];
SPLM.Preferences.PartSketch = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Preferences.PartSketch";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;